import { ADD_ROOM_REQUESTED,
  ADD_ROOM_FAILURE,
  ADD_ROOM_SUCCESS,
  FETCH_ROOM_REQUESTED,
  FETCH_ROOM_SUCCESS,
  FETCH_ROOM_FAILURE,
  FETCH_ROOM_BY_ID_SUCCESS,
  FETCH_ROOM_BY_ID_REQUESTED,
  FETCH_ROOM_BY_ID_FAILURE
} from "../actions/catelogue-types";

const initialState = {
  fetchRoomStatus: "pending",
  addRoomStatus: "pending",
  fetchRoomByIdStatus:'pending',
  rooms: [],
};

export default function locations(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case ADD_ROOM_REQUESTED:
      return {
        ...state,
        addRoomStatus: "request",
      };

    case ADD_ROOM_SUCCESS:
      return {
        ...state,
        addRoomStatus: "Success",
      };
    case ADD_ROOM_FAILURE:
      return {
        ...state,
        addRoomStatus: "failed",
      };

    case FETCH_ROOM_REQUESTED:
      return {
        ...state,
        fetchRoomStatus: "request",
        rooms:[],
      };

    case FETCH_ROOM_SUCCESS:
      return {
        ...state,
        fetchRoomStatus: "success",
        rooms: payload,
      };

    case FETCH_ROOM_FAILURE:
      return {
        ...state,
        fetchRoomStatus: "failed",
      };

      case FETCH_ROOM_BY_ID_REQUESTED:
        return {
          ...state,
          fetchRoomByIdStatus: "request",
        };
      case FETCH_ROOM_BY_ID_FAILURE:
      return {
        ...state,
        fetchRoomByIdStatus: "failed",
      };
    case FETCH_ROOM_BY_ID_SUCCESS:
      return {
        ...state,
        fetchRoomByIdStatus: "success",
        rooms: [...state.rooms, payload],
      };

    default:
      return state;
  }
}
